import React from 'react';
import { Link } from 'react-router-dom';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Table } from 'components/cosmos/table';
import { Tag } from 'components/cosmos/tag';
import { I18n } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import ClubDate, { FORMATS } from 'helpers/ClubDate';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import { ClassListViewActions } from 'modules/classManager/classListView/classListViewActions';

import './ClassTable.scss';

const handleEdit = () => {
  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category: EVENTS_CATEGORY.CLASS.EDIT_LIST_CLASS,
      action: EVENTS_INTERACTIONS.CLICK
    })
  });
};

const columnLabels = [
  'general.class',
  'class_manager.class_list.members',
  'class_manager.class_list.creation_date'
];

const ClassTable = ({ classes }) => {
  return (
    <Table variation="borderless" className="_border-0 class__table">
      <thead>
        <tr>
          {columnLabels.map((label) => (
            <th key={label} className="_text-1 _font-weight-bold">
              <I18n label={label} checkOnlineEvent />
            </th>
          ))}
          <th></th>
        </tr>
      </thead>
      <tbody>
        {classes.map((classItem) => (
          <tr key={classItem.id}>
            <td>
              <Link
                to={ROUTES.CLASS.EDIT.replace(':id', classItem.id)}
                className="_font-weight-bold _text-gray-700 _d-block"
                onClick={handleEdit}
              >
                {classItem.name}
              </Link>
              {classItem.defaultClass && (
                <Tag variation="blue" size="sm">
                  <I18n label="general.default_class_label" checkOnlineEvent />
                  <FontAwesomeIcon icon={faCircleInfo} className="_ml-1" />
                </Tag>
              )}
            </td>
            <td className="_text-lowercase _font-weight-bold _text-gray-600">
              <I18n
                label="class_manager.class_list.total_member"
                data={{ count: classItem.totalUsers || 0 }}
              />
            </td>
            <td className="_font-weight _text-gray-600">
              {ClubDate.resolve(classItem.createDate).format(FORMATS.DDMMYYYY)}
            </td>
            <td className="_text-right">
              <ClassListViewActions classItem={classItem} />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

ClassTable.propTypes = {
  classes: MobxPropTypes.arrayOrObservableArray
};

export default inject((store) => ({
  classes: store.ClassStore.classes
}))(ClassTable);
